// Racine de la boutique avec le préfixe du marché (ex. /es-mx/), pour garder la bonne devise.
const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

/**
 * LP offer cards : chaque bouton de carte vide le panier (option), ajoute sa
 * variante et redirige directement sur /checkout.
 * Gère aussi le scroll doux vers l'offre pour tous les liens "#offer" ou "#"
 * de la page (boutons des autres sections laissés sans lien).
 */
class LpOffer extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[data-ref="buy"]')];
    this.buttons.forEach((b) => b.addEventListener('click', this.#checkout));
  }

  disconnectedCallback() {
    this.buttons.forEach((b) => b.removeEventListener('click', this.#checkout));
  }

  #checkout = async (event) => {
    const button = event.currentTarget;
    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    this.buttons.forEach((b) => b.setAttribute('disabled', ''));
    button.classList.add('loading');

    try {
      if (this.dataset.clearCart === 'true') {
        await fetch(`${shopRoot}cart/clear.js`, { method: 'POST' });
      }
      const response = await fetch(`${shopRoot}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!response.ok) throw new Error('add failed');
      window.location.href = `${shopRoot}checkout`;
    } catch (error) {
      this.buttons.forEach((b) => b.removeAttribute('disabled'));
      button.classList.remove('loading');
    }
  };
}

if (!customElements.get('lp-offer')) {
  customElements.define('lp-offer', LpOffer);
}

if (!window.__lpOfferScroll) {
  window.__lpOfferScroll = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    const offer = document.querySelector('.lp-offer');
    if (!offer) return;
    const hash = href.includes('#') ? href.slice(href.indexOf('#') + 1) : null;
    if (hash === null) return;
    if (hash !== '' && hash !== offer.id) return;
    event.preventDefault();
    offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
